import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { icons } from '../../constants'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import LtsInputNumber from '../../components/lottus/lts-input-number'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function AjustarEstoque(props) {
  const [saldo, setSaldo] = useState(0)

  useEffect(() => {
    resetValues()
  }, [props.visible])

  const isConfirmarDisabled = () => {
    return !_.isNumber(saldo)
  }

  const onHide = () => {
    props.onHide()
  }

  const onConfirm = () => {
    props.onConfirm({ saldo, produtoUnidade: props.data })
    onHide()
  }

  const resetValues = () => {
    setSaldo(props.data.saldo)
  }

  return (
    <Dialog
      header={_.defaultTo(props.labelAjustar, 'Ajustar Estoque')}
      visible={props.visible}
      onHide={() => {
        onHide()
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid margin-top-dialogs">
        <div className="form-group p-col-12">
          <LtsInputNumber
            min={-9999999}
            value={saldo}
            onChange={(e) => setSaldo(e)}
            name={'novoSaldo'}
            label={_.defaultTo(props.labelSaldo, 'Novo Saldo')}
          />
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <Button
            label={_.defaultTo(props.labelConfirmar, 'Confirmar')}
            onClick={() => {
              onConfirm()
            }}
            disabled={isConfirmarDisabled()}
            icon={icons.CHECK_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    </Dialog>
  )
}
